var isStream = require('./isStream');

module.exports = function(stream) {
  if (!isStream(stream)) {
    return;
  }

  var streamType = stream.constructor.name;
  // Avoid StreamStream
  if (streamType === 'Stream') {
    streamType = '';
  }

  return '<' + streamType + 'Stream>';
};



//////////////////
// WEBPACK FOOTER
// ./~/vinyl/lib/inspectStream.js
// module id = 4050
// module chunks = 0